import styled from "styled-components";

import useFixaNavigate from "@coworker/apprestructured/src/shared/wrappers/FixaNavigate/useFixaNavigate";
import { Trans } from "@coworker/locales";

import FixaButton from "../../../../shared/wrappers/FixaButton/FixaButton";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
  margin-top: 20px;
  background-color: var(--grey100);
  padding: 32px 16px;
`;

const Description = styled.p`
  text-align: center;
`;

const StyledFixaButton = styled(FixaButton)`
  width: 290px;
`;

const NoArticlesFound = ({ clearFilters }: { clearFilters: () => void }) => {
  const navigate = useFixaNavigate();
  return (
    <Container>
      <h2>
        <Trans>noAddonsInThisAreaString</Trans>
      </h2>
      <Description>
        <Trans>noAddonsInThisAreaDescriptionString</Trans>
      </Description>
      <StyledFixaButton
        text={<Trans>goBackToRefillAreasString</Trans>}
        type="primary"
        onClick={() => navigate("/multi-order-addons")}
      />
      <StyledFixaButton
        text={<Trans>clearFiltersString</Trans>}
        type="secondary"
        onClick={clearFilters}
      />
    </Container>
  );
};

export default NoArticlesFound;
